import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppointmentSelectionSheetComponent } from '@sc/ui-components';
import {
  AppointmentValidationInputData,
  AppointmentValidationOutputData,
  AppointmentSheetValidationData,
} from '@sc/data-access-models';

@Component({
  selector: 'sc-appointment-validation-dialog',
  styleUrls: ['./appointment-validation-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [AppointmentSelectionSheetComponent],
  template: `
    <sc-appointment-selection-sheet
      [onlyReplacementVehicle]="data.onlyReplacementVehicle"
      [location]="data.location"
      [appointment]="data.appointment"
      [customer]="data.customer"
      [displayReplacementVehicleSelection]="
        data.displayReplacementVehicleSelection
      "
      [fitter]="data.fitter"
      (cancelEvent)="onCancelAppointment()"
      (validationEvent)="onValidateAppointment($event)"
    ></sc-appointment-selection-sheet>
  `,
})
export class AppointmentValidationDialogComponent {
  onCloseValue: AppointmentValidationOutputData;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AppointmentValidationInputData,
    private readonly dialogRef: MatDialogRef<
      AppointmentValidationDialogComponent,
      AppointmentValidationOutputData
    >
  ) {
    this.onCloseValue = {
      type: 'cancel',
    };
  }

  onCancelAppointment() {
    this.onCloseValue = {
      type: 'cancel',
    };

    this.dialogRef.close(this.onCloseValue);
  }

  onValidateAppointment(sheetValidationData: AppointmentSheetValidationData) {
    this.onCloseValue = {
      type: 'success',
      data: sheetValidationData,
    };

    this.dialogRef.close(this.onCloseValue);
  }
}
